import { useState } from 'react';
import { AgButton, AgInput } from 'src/components/ui';
import type { FilterItemProps } from './filterItemTypes';

export default function ScalarTextFilter({ updateFilter, filter, column, onClose }: FilterItemProps) {
  const colName = column.headerName ?? column.field;
  const [value, setValue] = useState(() => {
    const val = filter.where?.[0]?.has;
    return column.serverFilterValueTransform?.from?.(val) ?? val ?? '';
  });

  return (
    <>
      <div className="p-2">
        <AgInput size="sm" aria-label={colName} value={value} onChange={(val) => setValue(val)} />
      </div>
      <div className="flex justify-between gap-2 p-2 border-t border-neutral-5">
        <AgButton variant="destructive-white" onPress={() => updateFilter({ field: filter.field, where: [] })}>
          Clear
        </AgButton>
        <AgButton
          variant="primary"
          isDisabled={!value}
          onPress={() => {
            const v = column.serverFilterValueTransform?.to?.(value) ?? value;
            updateFilter({ field: filter.field, where: [{ has: v }] });
            onClose?.();
          }}
        >
          Apply
        </AgButton>
      </div>
    </>
  );
}
